import * as z from "zod/v4";
import { AnalyticsFilterType } from "./analytics-filter-type";
import { makeReportFilterSchema } from "./base-report-filter";

export enum ItemSoldFilterQuery {
  IS_GREATER_THAN = "isGreaterThan",
  IS_LESS_THAN = "isLessThan",
  WITHIN = "within",
}

export const ProductItemSoldFilterSchema = makeReportFilterSchema(
  AnalyticsFilterType.PRODUCT_NUM_SOLD,
  ItemSoldFilterQuery,
  z.union([z.number(), z.object({ min: z.number(), max: z.number() })]),
);

export const VariantItemSoldFilterSchema = makeReportFilterSchema(
  AnalyticsFilterType.VARIANT_NUM_SOLD,
  ItemSoldFilterQuery,
  z.union([z.number(), z.object({ min: z.number(), max: z.number() })]),
);

export type ItemSoldFilter =
  | z.infer<typeof ProductItemSoldFilterSchema>
  | z.infer<typeof VariantItemSoldFilterSchema>;
